<template>
  <v-menu
    bottom
    origin="center center"
    transition="scale-transition"
    class="dblock"
    full-width
  >
    <v-btn
      slot="activator"
      color="primary"
      block flat outline
      class="mb-2"
    >
      move to
    </v-btn>

    <v-list>
      <v-list-tile
        v-for="(list, index) in otherLists"
        :key="index"
        @click="moveJob(jobId, list.id)"
      >
        <v-list-tile-title>{{ list.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { handleJobMovingColumn } from '@/components/Mixins/handleJobMovingColumn'

export default {
  name: 'MoveJobButton',
  props: {
    jobId: {
      type: String,
      required: true
    },
    hasInvoice: {
      type: Boolean,
      required: true,
      default: false
    },
    listId: {
      type: Number,
      required: true
    },
    invoiceRef: {
      type: String
    }
  },
  mixins: [handleJobMovingColumn],
  data () {
    return {
      lists: [
        { id: 1, title: 'Leads' },
        { id: 2, title: 'Confirmed' },
        { id: 3, title: 'Current' },
        { id: 4, title: 'Invoiced' },
        { id: 5, title: 'Paid' }
      ],
      user: this.$store.getters.user
    }
  },
  computed: {
    otherLists () {
      // filter the list array down to all lists except this job's one for the move menu.
      return this.lists.filter((list) => list.id !== this.listId)
    }
  },
  methods: {
    async moveJob (jobId, newListId) {
      // if (await this.$root.$confirm.open('Move invoiced Job?', 'This job has an invoice marked as Sent. Do you really want to move it?', { color: 'red', negative: 'No, put it back', affirmative: 'yes' })) {
      const listId = this.listId
      const itemId = jobId
      const hasInvoice = this.hasInvoice || false
      const fromList = listId
      const toList = newListId
      const invoiceRef = this.invoiceRef
      await this.$store.dispatch('moveJob', { jobId: jobId, oldList: listId, newList: newListId })
      await this.handleJobMovingColumn(
        itemId,
        hasInvoice,
        fromList,
        toList,
        invoiceRef
      )
      // emit job deleted
      this.$emit('job-moved')
    // }
    }
  }
}
</script>
